import { FormattedMessage } from '@futrli/localisation';
import { INTERCOM_LAUNCHER_ID } from '@futrli/shared-services';
import clsx from 'clsx';
import React from 'react';
import styles from '../ds-controls.scss';

export const DatasourceAlreadyConnected = () => (
  <span className={clsx(styles.errorColour, styles.errorLink, 'uiTypeOtherAction')} id={INTERCOM_LAUNCHER_ID}>
    <FormattedMessage
      id="datasource.already_connected_issue"
      defaultMessage={`
          Something's gone wrong with your data import.
          We're really sorry this has happened. Click here to speak with support.
        `}
    />
  </span>
);
